export default __webpack_public_path__ + "static/media/1240_1250.be045a93.jpg";